// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, react:true*/
const host_re = /(holafreevpn)\.(com|org)$/;

export const get_host = opt=>{
    return host_re.test(opt.host) ? opt.host : 'hola.org';
};
